import {Component} from "@/event/calendar/dom/Component.ts";
import {DaysWholeHeader} from "@/event/calendar/days/DaysWholeHeader.ts";
import {DrawingContext} from "@/event/calendar/dom/DrawingContext.ts";
import {intersection, Rect} from "@/event/calendar/Shapes.ts";
import {ScrollComponent} from "@/event/calendar/dom/ScrollComponent.ts";
import {dc} from "@fd/editors/html/plugins/Keymap.ts";
import {DaysWholeBody} from "@/event/calendar/days/DaysWholeBody.ts";

export class DaysWholeArea extends Component {
	private header: DaysWholeHeader;
	private body: ScrollComponent;
	private rawBody: DaysWholeBody;

	constructor(wholeHeader: DaysWholeHeader, wholeBody: ScrollComponent, rawBody:DaysWholeBody) {
		super();
		this.header = wholeHeader;
		this.body = wholeBody;
		this.append(this.header).append(this.body);
		this.rawBody = rawBody;
	}

	placeChildren(dc: DrawingContext, cb: Rect) {
		this.header.x = cb.x;
		this.header.y = cb.y;
		this.header.width = this.header.gutterWidth;
		this.header.height = cb.height;

		this.body.x = cb.x + this.header.gutterWidth;
		this.body.y = cb.y;
		this.body.width = cb.width - this.header.gutterWidth;
		this.body.height = cb.height;
	}

	protected drawChildren(dc: DrawingContext, area: Rect) {
		try {
			dc.ctx.save();
			const toUpdate = intersection(area, { x: this.body.x, y: this.body.y, width: this.body.width, height: this.body.height});
			dc.ctx.translate(this.body.x, this.body.y);	// this.body will have different coordinates
			toUpdate.x = 0;
			toUpdate.y = 0;
			this.body.draw(dc, toUpdate);
			} finally {
			dc.ctx.restore();
		}
		// After body draw there should be known event stack height
		this.header.setRequiredHeight(this.rawBody.eventStackHeight, this.body.scrollY);

		try {
			dc.ctx.save();
			const toUpdate = intersection(area, { x: this.header.x, y: this.header.y, width: this.header.width, height: this.header.height});
			dc.ctx.translate(this.header.x, this.header.y);	// this.header will have different coordinates
			toUpdate.x = 0;
			toUpdate.y = 0;
			this.header.draw(dc, toUpdate);
		} finally {
			dc.ctx.restore();
		}
	}
}